import { createElement } from "react";
import * as react from "react";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { wrapTooltip, helperText } from "../ViewHelpers.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { TextField, Checkbox, Autocomplete, Typography } from "@mui/material";
import { map } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { Activity_ActivityType_AllActivityTypes, Activity_ActivityType__ColorCode } from "../Shared/Shared.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";

export function activityTypeHelperText(currentActivities) {
    let elems_4, elems_3, elems_2, elems_1;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        flexWrap: "wrap",
    }], (elems_4 = [helperText("dobbeltklikk på tidslinjen for å legge til aktivitet raskere."), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "flex-end",
        gap: 16 + "px ",
    }], (elems_3 = [MuiHelpers_createElement(Typography, [["children", `Viser: ${currentActivities} aktiviteter`]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        marginRight: 10,
        marginLeft: 10,
    }], (elems_2 = [MuiHelpers_createElement(Typography, [["style", {
        fontSize: 0.8 + "rem",
        color: "#aaa",
    }], ["children", "Aktivitetstyper"]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        gap: 5 + "px ",
    }], (elems_1 = [map((x_2) => {
        let elems, x, xs_1, x_1;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            fontSize: 1 + "rem",
        }], (elems = [(x = x_2, (xs_1 = [(x_1 = createElement("span", {
            style: {
                marginRight: 5,
                display: "inline-block",
                width: 1 + "em",
                height: 1 + "em",
                backgroundColor: Activity_ActivityType__ColorCode(x),
                borderRadius: 2,
            },
        }), wrapTooltip(toString(x), x_1)), toString(x)], react.createElement(react.Fragment, {}, ...xs_1)))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, Activity_ActivityType_AllActivityTypes())], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

/**
 * Component for multiple select, shows a searchable list of options with chips for selected items in the textbox.
 */
export function multipleSelectAutocomplete(label, items, isBig, selected, setSelection) {
    return MuiHelpers_createElement(Autocomplete, [["size", "small"], ["noOptionsText", `Ingen ${label.toLocaleLowerCase()}`], ["openOnFocus", true], ["selectOnFocus", true], ["clearOnBlur", true], ["handleHomeEndKeys", true], ["disableCloseOnSelect", true], ["multiple", true], ["options", Array.from(items)], ["getOptionLabel", (x) => x.Name], ["isOptionEqualToValue", ((x_1, y) => (x_1.Id === y.Id))], ["style", createObj(toList(delay(() => (!isBig ? append(singleton(["flexGrow", 1]), delay(() => append(singleton(["flexBasis", 0]), delay(() => append(singleton(["flexShrink", 1]), delay(() => append(singleton(["maxWidth", 400]), delay(() => singleton(["minWidth", 200]))))))))) : append(singleton(["maxWidth", 400]), delay(() => singleton(["minWidth", 200])))))))], ["value", Array.from(selected)], ["onChange", (_arg, v, _arg_1) => {
        setSelection(v);
    }], ["renderOption", (delegateArg, delegateArg_1, delegateArg_2) => {
        const props = Object.entries(delegateArg);
        const p = delegateArg_1;
        return createElement("li", createObj(toList(delay(() => append(props, delay(() => append(singleton(["key", `${p.Id}-${p.Name}`]), delay(() => {
            let elems;
            return singleton((elems = [MuiHelpers_createElement(Checkbox, [["checked", delegateArg_2.selected], ["style", {
                marginRight: 8,
            }]]), p.Name], ["children", reactApi.Children.toArray(Array.from(elems))]));
        }))))))));
    }], ["renderInput", (p_1) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(p_1), delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["color", "primary"]), delay(() => singleton(["label", (selected.length === 0) ? ("Alle " + label) : label]))))))))))]]);
}

/**
 * Component for multiple select, shows a searchable list of options with chips for selected items in the textbox.
 */
export function vesselMultipleSelectAutocomplete(label, items, isBig, selected, setSelection, favoritesOnly) {
    const items$0027 = !favoritesOnly ? items : items.filter((v) => v.Favorite);
    return MuiHelpers_createElement(Autocomplete, [["size", "small"], ["openOnFocus", true], ["selectOnFocus", true], ["clearOnBlur", true], ["handleHomeEndKeys", true], ["disableCloseOnSelect", true], ["multiple", true], ["options", Array.from(items$0027)], ["isOptionEqualToValue", ((x, y) => (x.Id === y.Id))], ["getOptionLabel", (x_1) => x_1.Name], ["style", createObj(toList(delay(() => (!isBig ? append(singleton(["flexGrow", 1]), delay(() => append(singleton(["flexBasis", 0]), delay(() => append(singleton(["flexShrink", 1]), delay(() => append(singleton(["maxWidth", 400]), delay(() => singleton(["minWidth", 200]))))))))) : append(singleton(["maxWidth", 400]), delay(() => singleton(["minWidth", 200])))))))], ["value", Array.from(selected)], ["onChange", (_arg, v_1, _arg_1) => {
        setSelection(v_1);
    }], ["renderOption", (delegateArg, delegateArg_1, delegateArg_2) => {
        const props = Object.entries(delegateArg);
        const p = delegateArg_1;
        return createElement("li", createObj(toList(delay(() => append(props, delay(() => append(singleton(["key", `${p.Id}-${p.Name}`]), delay(() => {
            let elems;
            return singleton((elems = [MuiHelpers_createElement(Checkbox, [["checked", delegateArg_2.selected], ["style", {
                marginRight: 8,
            }]]), p.Name], ["children", reactApi.Children.toArray(Array.from(elems))]));
        }))))))));
    }], ["renderInput", (p_1) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(p_1), delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["color", "primary"]), delay(() => singleton(["label", (selected.length === 0) ? ("Alle " + label) : label]))))))))))]]);
}

//# sourceMappingURL=Helpers.js.map
